// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import { toast } from 'react-toastify';

import Modal from './Modal';

export default class CreateForm extends Modal {

    state = {
        name: "",
        alert: false
    }

    renderContent = () => {

        return (<div className="modal-content modal-center">
            
            <div style={{
                height: 150
            }} />

            <h1>Create a new <strong>form</strong></h1>

            <p>Forms in Stax·ai allow you to view and edit document <strong>Fields</strong> in a more intuitive manner than a list. Use forms to build data integrity checks or quality control workflows within your business or to collect data for analysis.</p>

            <br />

            <form onSubmit={(e) => {
                e.preventDefault();
                e.stopPropagation();
                this.setState({ alert: false });
                if (this.state.name.length < 10) {
                    this.setState({ alert: true });
                    return toast.error("Form name must be at least 10 characters long.");
                }
                this.props.createForm(this.state.name);
            }}>

                <input
                    id="formname"
                    name="formname"
                    type="text"
                    className={"input-inline-text" + (this.state.alert ? " input-error" : "")}
                    placeholder="Enter new form name..."
                    style={{width: 330 }}
                    value={this.state.name}
                    onClick={e => e.stopPropagation()}
                    onChange={e => this.setState({ name: e.target.value, alert: false })}
                />

                <input
                    type="submit"
                    value="Create"
                    className="input-inline-submit"
                />
            
            </form>
            
        </div>);
    }

};